import { createContext } from 'react';

/** Catalog requests wait for the SDK's existing 24-hour snapshot restore. */
export const PersistenceRestoredContext = createContext(false);
